import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

//import 'sticky-kit/dist/sticky-kit.js';
import '../vendor/sticky-kit.js';
$(document).ready(function () {
    // ELEMENTS
    var body = $("html, body");
    var header = $(".site-header");
    
    var $headerClose = $(".site-header__close");
    var $overlayToggle = $(".js-toggle-overlay");
    var $overlayLink;
    
    // RESIZE
    var resizeTimer;

    function resizeFunction() {
        // resize functions
        windowSize();
        bankrupcySticky();
    };

    $(window).resize(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resizeFunction, 50);
    });

    resizeFunction();

    var windowWidth = $(window).width();
    var windowHeight = $(window).height();

    function windowSize() {
        windowWidth = $(window).width();
        windowHeight = $(window).height();
    }

    windowSize();

    // OVERLAY SHOW/HIDE
    function hideOverlays() {
        $headerClose.hide();
        $(".overlay-content, .overlay").hide();
    }

    hideOverlays();

    function fadeInOverlay() {
        $headerClose.show();
        $("html").addClass("overlay-visible");
        $(".overlay").show();
        $("#" + $overlayLink).fadeIn();

        if ($overlayLink == "search-layer") {
            console.log("init search-layer");
            $(".site-search__text").focus();
        }
    }

    function fadeOutOverlay() {
        $(".overlay-content").fadeOut();
        $headerClose.hide();
        $("html").removeClass("overlay-visible");
        $(".overlay").hide();

        if ($("#search-layer").is(":visible")) {
            console.log("if search visible");
            $(".js-sitesearch-autocomplete").remove();
            $(".js-sitesearch-commonqueries").show();
            $(".site-search__text").val("");
        }

    }

    $overlayToggle.on("click", function (event) {
        event.preventDefault();
        $overlayLink = $(this).attr("data-id");
        fadeInOverlay();
    });

    $headerClose.on("click", function (event) {
        fadeOutOverlay();
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27 && $(".overlay").is(":visible")) {
            fadeOutOverlay();
        }
    });


    // HEADER VISIBLE ON SCROLL
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $(".site-header").outerHeight(); 

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll && !$("html").hasClass("overlay-visible")) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop(); 
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $(".site-header").removeClass('site-header--nav-down').addClass('site-header--nav-up');
        }
        else {  
            if (st + $(window).height() < $(document).height()) { 
                $(".site-header").removeClass('site-header--nav-up').addClass('site-header--nav-down');
            } 
        }
        lastScrollTop = st;
    }

    // TOGGLE NAV LEVELS
    $(".site-menu__child, .site-menu__grandchild").hide();
    $(".site-menu .js-toggle i").removeClass("fa-angle-up").addClass("fa-angle-down");
    ;

    $(".site-menu .js-toggle").on("click", function (event) {

        event.preventDefault();

        if ($(this).hasClass("toggle-visible")) {
            $(this).children("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            $(this).removeClass("toggle-visible").next().slideUp();
        } else {
            $(this).children("i").removeClass("fa-angle-down").addClass("fa-angle-up");
            $(this).addClass("toggle-visible").next().slideDown();
        }

    });

    $(".site-menu__item-linktoggle").on("click", function (event) {

        event.preventDefault();

        if ($(this).next().hasClass("toggle-visible")) {
            $(this).next().children("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            $(this).next().removeClass("toggle-visible").next().slideUp();
        } else {
            $(this).next().children("i").removeClass("fa-angle-down").addClass("fa-angle-up");
            $(this).next().addClass("toggle-visible").next().slideDown();
        }

    });

    // HELPER METHOD TO ALLOW CLICK ON MENU ANCHOR ELEMENT.
    $('ul.nav li.dropdown a.dropdown-toggle').click(function (event) {
        event.stopPropagation();
    });

    // HELPER METHOD TO ALLOW DROPDOWM MENU TO OPEN ON HOVER AND POSITION DROPDOWN MENU ARROW RELATIVELY TO MENU ITEM.
    $('ul.nav li.dropdown').hover(function () {
        var menuLinkIElement = $(this);
        var dropDownMenuElement = menuLinkIElement.find('.dropdown-menu');

        if (dropDownMenuElement.length > 0) {
            // TIMEOUT (DELAY) TO MAKE SURE THAT THE MENU ELEMENT CREATED WHEN WE TRY TO ACCESS THE OFFSET VALUES.
            setTimeout(function () {
                menuLinkIElement.addClass('open');
                var menuLinkIElementWidth = menuLinkIElement.width();
                var leftPosition = menuLinkIElement.position().left + (menuLinkIElementWidth / 2);
                if (menuLinkIElement.children().hasClass('mega-dropdown-menu')) {
                    dropDownMenuElement.css('left', leftPosition - (menuLinkIElementWidth / 2) + 'px');
                    // ADJUST OFFSET WITH 70 PX
                    menuLinkIElement.find('.dd-arrow').css('left', leftPosition - dropDownMenuElement.position().left + 70 + 'px');
                } else if (menuLinkIElement.children().hasClass('default-dropdown-menu')) {
                    var diff = (dropDownMenuElement.width() - menuLinkIElement.width()) / 2;
                    var left = menuLinkIElement.position().left - diff;
                    dropDownMenuElement.css('left', left + 'px');
                }

                var otherProductsServicesSections = $('.products-services__item-container-section').filter(function (index, section) {
                    return !$(section).hasClass('our-services')
                });

                var sectionHeights = otherProductsServicesSections.map(function (index, section) {
                    return $(section).height()
                });

                var maxHeight = sectionHeights.toArray().reduce(function (a, b) {
                    return Math.max(a, b);
                });

                var ourServicesSectionHeight = maxHeight - $('.products-services__our-services .button-container a').height();
                $('.products-services__item-container-section.our-services ul').height(ourServicesSectionHeight);
            }, 0);
        }
    }, function () {
        $(this).removeClass('open');
    });


    // SHOW ACTIVE LINKTRAIL IN NAV
    $(".site-menu .active").parentsUntil(".site-menu").show().addClass("activeparent");
    $(".site-menu .activeparent > a").next().addClass("toggle-visible");
    $(".site-menu .activeparent > .js-toggle i").removeClass("fa-angle-down").addClass("fa-angle-up");

    // CUSTOM FORM FOR LÄNSFAKTA/BRANSCHFAKTA
    $(document).on('change', '.radio__report', function () {
        var radiovalue = $('input[name=RadioButtonSelectedValue]:checked', document).val();

        $.ajax({
            type: "POST",
            url: '/ReportFormBlock/PopulateDropdown',
            cache: false,
            data: {value: radiovalue},
            success: function (data) {
                $("#dropdownlistdiv").html(data);
            },
            error: function (e) {
                console.log("Something went wrong with the AJAX request!");
                console.log(e.responseText);
            }
        });
    });

    // Show more FAQ categories
    $(function () {
        var numberOfTeasers = $("#NumberOfTeasers").val();
        var currentPageId = $("#CurrentPageId").val();
        var loadCount = 1;

        $("#loadMore").on("click", function (e) {
            e.preventDefault();
            var url = "/FaqStartPage/LoadMoreTeasers/";
            $.ajax({
                url: url,
                data: {
                    size: loadCount * numberOfTeasers,
                    numberOfTeasers: numberOfTeasers,
                    currentPageId: currentPageId
                },
                cache: false,
                type: "POST",
                success: function (data) {
                    if (data.length !== 0) {
                        $(data.ModelString).appendTo(".categorylinks--inner").fadeIn(2000);
                        $("#loadMore").hide();
                    }

                    var ajaxModelCount = data.ModelCount - (loadCount * numberOfTeasers);
                    if (ajaxModelCount <= 0) {
                        $("#loadMore").hide().fadeOut(2000);
                    }
                },
                error: function (xhr, status, error) {
                    console.log(xhr.responseText);
                    alert("message : \n" + "An error occurred, for more info check the js console" + "\n status : \n" + status + " \n error : \n" + error);
                }
            });

            loadCount = loadCount + 1;
        });
    });

    // faq Thumbs up voting
    $(function () {
        var currentPageId = $("#CurrentPageId").val();

        $("#thumbsup").on("click", function (e) {
            e.preventDefault();
            var url = "/FaqQuestionPage/GiveThumbsUp/";
            $.ajax({
                url: url,
                data: {isthumbsup: true, pageId: currentPageId},
                cache: false,
                type: "POST",
                success: function (data) {

                    if (data) {
                        $("#thumbsup").addClass("faqvote__button--voted");
                    }
                },
                error: function (xhr, status, error) {
                    console.log(xhr.responseText);
                    console.log("message : \n" + "An error occurred, for more info check the js console" + "\n status : \n" + status + " \n error : \n" + error);
                }
            });
        });
    });

    // FIND LIST BLOCK
    $(document).on("change", ".findListBlock-input", function () {
        FilterFindListBlocks();
    });

    $(".findListBlock-input[type='checkbox']:checked").each(function () {
        FilterFindListBlocks();
        return false;
    });

    function FilterFindListBlocks() {
        var selected = [];
        var numberOfTeasers = $("#NumberOfTeasers").val();
        var totalNumberOfTeasers = $("#TotalNumberOfTeasers").val();
        var currentPageId = $("#CurrentPageId").val();

        $(".findListBlock-input[name=type]:checked").each(function () {
            selected.push($(this).attr("id"));
        });

        $.ajax({
            type: "POST",
            url: '/FindListBlock/FilterBlocks',
            cache: false,
            data: {
                idArray: selected,
                numberOfTeasers: numberOfTeasers,
                totalNumberOfTeasers: totalNumberOfTeasers,
                currentPageId: currentPageId
            },
            success: function (data) {
                $("#PageList").html(data);
            },
            error: function (e) {
                console.log("Something went wrong with the AJAX request!");
                console.log(e.responseText);
            }
        });
    }

    $(function () {
        $('.productcategoryblock__menu a').click(function (e) {
            e.preventDefault(); // Prevent the default link behavior           

            var sortBy = $('#categoryTabList').data('sort-by');

            var categoryName = $(this).attr('class');

            // Remove the 'active' class from all <li> elements
            $('.productcategoryblock__menu li').removeClass('active');

            // Add the 'active' class to the parent <li> of the clicked link
            $(this).closest('li').addClass('active');
            
            // Scroll to the clicked button
            $('html, body').animate({
                scrollTop: $('.productcategoryblock').offset().top - 80
            }, 250);

            $.ajax({
                type: "POST",
                url: '/ProductCategoryCardListBlock/FilterProducts',
                cache: false,
                data: { value: categoryName, sortBy: sortBy },
                success: function (data) {
                    $("#" + categoryName).html(data);
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        });
    });

    // Quick search
    $(function () {
        var minlength = 3;
        var lastValue = "";
        var timeOut;

        $("#search-input").keyup(function (e) {
            var code = e.which;
            if (code != 13) { // Don't execute a search on enter since that trigger a post
                var query = $("#search-input").val();

                if (query.length >= minlength && query != lastValue) {
                    lastValue = query;
                    if (timeOut) {
                        clearTimeout(timeOut);
                    }

                    timeOut = setTimeout(function () {
                        doSearch(query);
                    }, 300);
                }
                // If you mark and delete the given letters in search box
                else if (query != lastValue && query.length == 0) {
                    lastValue = query;
                    if (timeOut) {
                        clearTimeout(timeOut);
                    }

                    timeOut = setTimeout(function () {
                        doSearch(query);
                    }, 300);
                }
            } else {

                if (timeOut) {
                    clearTimeout(timeOut);
                }

                timeOut = setTimeout(function () {
                    // Do nothing here since enter/submit triggers a post, only for delaying purpose
                    // delay is needed, otherwise it will cause an error if enter is hit too fast
                }, 300);
            }
        });
    });

    $('.site-search__loading').hide();

    function doSearch(query) {
        $.ajax({
            type: "POST",
            dataType: "html",
            contentType: "application/json; charset=utf-8",
            url: '/FindSearchPage/QuickSearch',
            data: JSON.stringify({search: query}),
            beforeSend: function () {
                $('.site-search__loading').show();
                $('.js-sitesearch-commonqueries').hide();
            },
            success: function (data) {
                $('.site-search__loading').hide();
                $("#QuickSearch").html(data);
            },
            error: function (e) {
                console.log("Something went wrong with the AJAX request in keyup function!", e.responseText);
                $('.js-sitesearch-commonqueries').show();
            }
        });
    }

    // FLOATING LABELS
    //var showClass = 'showLabel';

    //$('.FormTextbox__Input').on('checkval', function () {
    //    var label = $(this).prev('label');
    //    if (this.value !== '') {
    //        label.addClass(showClass);
    //    } else {
    //        label.removeClass(showClass);
    //    }
    //}).on('keyup', function () {
    //    $(this).trigger('checkval');
    //});

    // TEXT TOGGLE
    $(".texttoggle__linktext--active").hide();
    $('.texttoggle__trigger').on('click', function () {
        if ($(this).prev().hasClass("texttoggle__fold--active")) {
            $(this).addClass("texttoggle__trigger--active");
            $(this).prev().removeClass("texttoggle__fold--active");
            $(this).children(".texttoggle__linktext--default").hide();
            $(this).children(".texttoggle__linktext--active").show();
        } else {
            $(this).removeClass("texttoggle__trigger--active");
            $(this).prev().addClass("texttoggle__fold--active");
            $(this).children(".texttoggle__linktext--active").hide();
            $(this).children(".texttoggle__linktext--default").show();
        }
        //$(this).hide();
    });

    /// <summary>
    /// UCSE-593 For Accordion in teaser list block(Expand and collapse the data)
    /// </summary>
    $('.texttoggle__trigger__accordion').on('click', function () {
        if ($(this).prev().hasClass("texttoggle__fold--active__accordion")) {
            $(this).addClass("texttoggle__trigger--active__accordion");
            $(this).prev().removeClass("texttoggle__fold--active__accordion");
            $(this).children(".texttoggle__linktext--default").hide();
            $(this).children(".texttoggle__linktext--active").show();
        } else {
            $(this).removeClass("texttoggle__trigger--active__accordion");
            $(this).prev().addClass("texttoggle__fold--active__accordion");
            $(this).children(".texttoggle__linktext--active").hide();
            $(this).children(".texttoggle__linktext--default").show();
        }
        //$(this).hide();
    });

    // VIDEO AUTOPLAY
    $('.videoblock').on('click', function (e) {
        $(this).children(".videoblock__background").fadeOut(250);
        $(this).children("iframe")[0].src += "&autoplay=1";
        e.preventDefault();
    });

    // TOGGLE BLOGITEM
    $(".js-blogitem__toggle").on("click", function () {

        //console.log("blogitem click");

        if ($(this).parent().hasClass("blogitem__content--folded")) {
            $(this).html("Minimera inlägget").addClass("blogitem__toggle--active");
            ;
            $(this).parent().removeClass("blogitem__content--folded").addClass("blogitem__content--visible");
        } else {
            $(this).html("Visa hela inlägget").removeClass("blogitem__toggle--active");
            $(this).parent().removeClass("blogitem__content--visible").addClass("blogitem__content--folded");
        }
    });

    $(".sharelinks").stick_in_parent({
        offset_top: 130
    });

    $(".fixedform").stick_in_parent({
        offset_top: 150
    });

    function bankrupcySticky() {
        if (windowWidth >= 1024) {
            $(".bankrupcysticky").stick_in_parent({
                offset_top: 120
            });
        } else {
            $(".bankrupcysticky").trigger("sticky_kit:detach");
        }
    }

    bankrupcySticky();

    // TOGGLE faqvote__form
    $(".faqvote__form").hide();

    $(".js-toggle-faqvote__form").on("click", function (e) {
        e.preventDefault();
        $(this).addClass("active");
        $(".faqvote__form").slideDown();
    });

    // ACTIVE PARENT 
    $(".treenav li.active").parents("li").addClass("activeparent");

    // TOGGLE TREEENAV 

    if ($(".treenav--toggle .treenav li.active").length) {
        var treeactive = $(".treenav--toggle").find("li.active a").text();
        $("<span class='trigger'>" + treeactive + "</span>").prependTo(".treenav--toggle .treenav");
        $(".treenav--toggle  .treenav > ul").hide().addClass("d-none");
    }

    $("body").on("click", function () {
        if ($(".treenav--toggle .treenav > ul").hasClass("visible")) {

            $(".treenav--toggle .treenav > ul").addClass("d-none").removeClass("active");
            $(".treenav--toggle .treenav > ul").slideUp();
            $(".treenav--toggle .trigger").show();

        }
    });

    $(".treenav--toggle .trigger").on("click", function (e) {
        e.stopPropagation();
        $(".treenav--toggle .treenav > ul").removeClass("d-none");
        $(".treenav--toggle .treenav > ul").slideDown("slow", function () {
            $(".treenav--toggle .trigger").slideUp(100);
            $(".treenav--toggle  .treenav > ul").addClass("visible");
        });
    });

    $('.products-shortcut__mainbody a').addClass('btn btn-enento-primary');

    $('#startpage-pills.nav-pills a').on('shown.bs.tab', function (event) {
        //To prevent scrolling to top on tab click
        event.preventDefault();
        event.stopImmediatePropagation();
    });
        
    $("input[type='email']").on('change keyup paste',
        function () {
            $(this).val($(this).val().toLowerCase());
        });

    //simple_numbers_no_ellipses (Pagination)
    $.fn.DataTable.ext.pager.simple_numbers_no_ellipses = function(page, pages){
        var numbers = [];
        var buttons = $.fn.DataTable.ext.pager.numbers_length;
        var half = Math.floor( buttons / 2 );

        var _range = function ( len, start ){
            var end;

            if ( typeof start === "undefined" ){
                start = 0;
                end = len;

            } else {
                end = start;
                start = len;
            }

            var out = [];
            for ( var i = start ; i < end; i++ ){ out.push(i); }

            return out;
        };


        if ( pages <= buttons ) {
            numbers = _range( 0, pages );

        } else if ( page <= half ) {
            numbers = _range( 0, buttons);

        } else if ( page >= pages - 1 - half ) {
            numbers = _range( pages - buttons, pages );

        } else {
            numbers = _range( page - half, page + half + 1);
        }

        numbers.DT_el = 'span';

        return [ 'previous', numbers, 'next' ];
    };
    $('.brandpage .settings-mobile-menu .dropdown-menu a').on('click', function(){
        $('.brandpage .settings-mobile-menu .dropdown-menu a').removeClass('active');
        let activePill = $(this).find('span').text();
        $('.brandpage .dropdown-toggle').html(activePill + '<span class="caret"></span>');
    });
    if ($('.startpage').length > 0) {
        if (document.cookie.indexOf("CookieInformationConsent") > 0) {
            if (document.cookie.indexOf("redirectPopupShown=true") < 0) {
                $('#popupModal').modal({backdrop: 'static', keyboard: false})
                $("#popupModal").modal("show");
                document.cookie = "redirectPopupShown=true;";
            }
        }
    }

    $(document).ready(function () {
        $('.unexpectednotification-angle').on('click', function () {
            var icon = $(this).find('i');
            var toggleMore = $('#toggleMore');
            var toggleLess = $('#toggleLess');
            // Toggle the icon class
            if (icon.hasClass('fa-angle-down')) {
                icon.removeClass('fa-angle-down').addClass('fa-angle-up');
                toggleMore.hide();
                toggleLess.show();
            } else {
                icon.removeClass('fa-angle-up').addClass('fa-angle-down');
                toggleLess.hide();
                toggleMore.show();
            }
        });
    });
});